module.exports = __webpack_public_path__ + "static/media/logo.33a96a02.jpg";